export default __webpack_public_path__ + "static/Fig 9 - PV Module & Rack Detail-7870aece9c67a8ee01c33f8246c649ae.pdf";